document.querySelectorAll('.NewBuildingsList__list').forEach((el) => {
    new LoadMoreBtn(el, '.NewBuildingsList__more', '.HouseItem', null, HouseItemInit);
})

